<template>
    <div>
      <div class="row">
        <div class="col-md-12">
          <div v-if="showSection!=='Monitor'">
            <!-- Dashboard Events Section -->
            <div v-if="loading" class="col-md-12">
              <div class="loader-box">
                <div class="loader-30"></div>
              </div>
            </div>
            <div v-else class="col-md-12">
              <div class="dashboard-events-main-container">
                <!-- Header inside the container -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="events-header">
                      <h2 class="events-title custom-font-32">Latest Events</h2>
                    </div>
                  </div>
                </div>

                <!-- Table Container with padding -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="dashboard-table-container table-responsive-custom datatable-vue text-left">
                      <b-table
                        class="dashboard-events-table custom-font-20"
                        borderless
                        show-empty
                        stacked="md"
                        :items="event_data"
                        :filter="filter"
                        @filtered="onFiltered"
                        :fields="tablefields"
                        :per-page="perPage"
                      >
                        <template #cell(mName)="data">
                         <span class="event-name cust_txt custom-font-16" v-if="monitor_data.name" :title="monitor_data.name">{{ monitor_data.name }}</span>
                          <span class="event-name cust_txt custom-font-16" v-else :title="data.item.mName">{{data.item.mName}}</span>
                        </template>
                        <template #cell(event)="data">
                          <span
                            v-if="data.item.event == 'start'"
                            class="event-badge status-started custom-font-16"
                          >
                            <img src="@/assets/icons/color-started-icon.svg" alt="Started" width="16" height="16">
                            Started
                          </span>
                          <span
                            v-if="data.item.event == 'pause'"
                            class="event-badge status-paused custom-font-16"
                          >
                            <img src="@/assets/icons/color-pause-icon.svg" alt="Pause" width="16" height="16">
                            Pause
                          </span>
                          <span
                            v-if="data.item.event == 'down'"
                            class="event-badge status-down custom-font-16"
                          >
                            <img src="@/assets/icons/color-down-icon.svg" alt="Down" width="16" height="16">
                            Down
                          </span>
                          <span
                            v-if="data.item.event == 'up'"
                            class="event-badge status-up custom-font-16"
                          >
                            <img src="@/assets/icons/color-up-icon.svg" alt="Up" width="16" height="16">
                            Up
                          </span>
                        </template>
                        <template #cell(createdAt)="data">
                          <span class="custom-font-16">{{changeDateFormate(data.item.createdAt)}}</span>
                        </template>
                        <template #empty>
                          <div class="no-data-wrapper">
                            <img src="../assets/icons/data-not-found.svg" alt="Data Not Found" class="no-data-image" />
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
                
                <!-- Dashboard Pagination Component -->
                
                <!-- Complex pagination - hidden on small screens via CSS -->
                <div class="complex-pagination-wrapper">
                  <pagination-component
                    class="pr-0 pl-0 border-0"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :total-items="totalRowsCount"
                    :page-options="pageOptions"
                    @change-page="getEvent"
                    @update-per-page="updatePerPage"
                  />
                </div>
                
                <!-- Simple pagination - hidden on large screens via CSS -->
                <div class="simple-pagination-container">
                  <div class="simple-pagination-wrapper d-flex justify-content-between align-items-center">
                    <div class="per-page-selector-wrapper d-flex align-items-center">
                      <span class="per-page-label-simple">Show:</span>
                      <b-form-select
                        class="per-page-select-simple"
                        v-model="perPage"
                        :options="pageOptions"
                        @change="updatePerPage"
                      ></b-form-select>
                    </div>
                    <div class="pagination-controls d-flex align-items-center">
                      <button 
                        class="simple-page-btn-dashboard ml-3 mr-2"
                        :disabled="currentPage == 1"
                        @click="getEvent('prev')"
                      >
                        Previous
                      </button>
                      <button 
                        class="simple-page-btn-dashboard"
                        :disabled="event_data.length < perPage"
                        @click="getEvent('next')"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Events page with new Figma design -->
          <div v-else>
            <div v-if="loading" class="col-md-12">
                <div class="loader-box">
                  <div class="loader-30"></div>
                </div>
              </div>
            <div v-else class="col-md-12">
              <div class="events-main-container">
                <!-- Header inside the container -->
                <div class="d-flex flex-nowrap justify-content-between align-items-center mt-3">
                  <div>
                    <h2 class="events-page-title custom-font-32 mb-0">Latest</h2>
                  </div>
                  <div>
                    <div class="per-page-info-box d-flex align-items-center">
                      <img src="@/assets/icons/per-page.svg" alt="Per page" class="per-page-icon mr-2" />
                      <span class="per-page-label">Per page : </span>
                      <div class="select-wrapper">
                        <b-form-select
                          class="per-page-select"
                          v-model="perPage"
                          :options="pageOptions"
                          @change="updatePerPage"
                        ></b-form-select>
                        <i class="icofont icofont-simple-down select-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Table Container with padding -->
                <div class="row mx-n4">
                  <div class="col-md-12 px-0">
                    <div class="events-table-container table-responsive-custom text-left">
                <b-table
                        class="events-page-table custom-font-20"
                        borderless
                  show-empty
                  stacked="md"
                  :items="event_data"
                  :filter="filter"
                  @filtered="onFiltered"
                  :fields="tablefields"
                  :per-page="perPage"
                >
                  <template #cell(mName)="data">
                          <span class="monitor-name-text custom-font-16" v-if="monitor_data.name" :title="monitor_data.name">{{ monitor_data.name }}</span>
                          <span class="monitor-name-text custom-font-16" v-else :title="data.item.mName">{{data.item.mName}}</span>
                  </template>
                  <template #cell(event)="data">
                    <span
                      v-if="data.item.event == 'start'"
                            class="event-badge status-started custom-font-16"
                    >
                            <img src="@/assets/icons/color-started-icon.svg" alt="Started" width="16" height="16">
                            Started
                          </span>
                    <span
                      v-if="data.item.event == 'pause'"
                            class="event-badge status-paused custom-font-16"
                    >
                            <img src="@/assets/icons/color-pause-icon.svg" alt="Pause" width="16" height="16">
                            Pause
                          </span>
                    <span
                      v-if="data.item.event == 'down'"
                            class="event-badge status-down custom-font-16"
                    >
                            <img src="@/assets/icons/color-down-icon.svg" alt="Down" width="16" height="16">
                            Down
                          </span>
                    <span
                      v-if="data.item.event == 'up'"
                            class="event-badge status-up custom-font-16"
                    >
                            <img src="@/assets/icons/color-up-icon.svg" alt="Up" width="16" height="16">
                            Up
                          </span>
                  </template>
                  <template #cell(createdAt)="data">
                          <span class="custom-font-16">{{changeDateFormate(data.item.createdAt)}}</span>
                  </template>
                </b-table>
              </div>
                  </div>
                </div>
                
                <!-- Events Page Pagination Component -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="simple-pagination-bar d-flex justify-content-space-between align-items-center mt-3 mb-1">
                      <span class="page-info-text custom-font-16">Page no. {{ currentPage }}</span>
                      <div class="pagination-btn-group d-flex align-items-center">
                        <button 
                          class="simple-page-btn mr-2"
                          :disabled="currentPage == 1"
                          @click="getEvent('prev')"
                        >
                          Previous
                        </button>
                        <button 
                          class="simple-page-btn"
                          :disabled="event_data.length < perPage"
                          @click="getEvent('next')"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
  
<script>
import moment from 'moment'
import DashboardController from "../../services/dashboardController";
import PaginationComponent from '../components/PaginationComponent.vue';
export default {
  name: "Event",
  components: {
    PaginationComponent
  },
  props:{monitor_id:String,monitor_data:Object,dateRanges:Object,update_filter:Number},
  data() {
    return {
      event_data: [],
      filter: null,
      totalRows: 1,
      totalRowsCount: 0,
      currentPage: 1,
      perPage: 10, // Default per page value matches Figma
      pageOptions: [10, 20, 50], // 20 is included
      loading: false,
      showSection: '',
      tablefields: [
        { key: "event", label: "Event", sortable: false },
        { key: "createdAt", label: "Started At", sortable: false },
      ],
    };
  },
  mounted() {
    this.showSection = this.$route.name || 'Dashboard';
    // Removed perPage overwrite logic to avoid mismatch with options
    this.getEvent('', this.dateRanges);
    if(Object.keys(this.monitor_data).length == 0){
      this.tablefields.unshift({ key: "mName", label: "Name", sortable: true })
    }
  },
  watch:{
    async monitor_id(){
      this.currentPage = 1
      await this.getEvent('', this.dateRanges)
    },
    async update_filter(){
      await this.getEvent('', this.dateRanges)
    }
  },
  methods: {
    changeDateFormate(d){
        return moment(d).format('D/M/YYYY, hh:mm A')
    },
    async getEvent(txt, dateRange) {
      // Handle pagination navigation
      if(txt == 'next'){
        this.currentPage++;
      } else if(txt == 'prev' && this.currentPage > 1){
        this.currentPage--;
      }
      
      // Build query parameters
      var payload = '?currentPage='+this.currentPage+'&pageSize='+this.perPage;
      
      // Handle date range if provided
      if(dateRange){
        // Create copies to avoid modifying original objects
        const startDate = dateRange.startDate instanceof Date ? dateRange.startDate.toISOString() : dateRange.startDate;
        const endDate = dateRange.endDate instanceof Date ? dateRange.endDate.toISOString() : dateRange.endDate;
        payload += '&sdate='+startDate+'&edate='+endDate;
      }
      
      // Add monitor ID if available
      if(this.monitor_id && this.monitor_id != null){
        payload = '?mid='+this.monitor_id+'&currentPage='+this.currentPage+'&pageSize='+this.perPage;
         if(dateRange){
          const startDate = dateRange.startDate instanceof Date ? dateRange.startDate.toISOString() : dateRange.startDate;
          const endDate = dateRange.endDate instanceof Date ? dateRange.endDate.toISOString() : dateRange.endDate;
          payload += '&sdate='+startDate+'&edate='+endDate;
        }
      }
      
      this.loading = true;
      let response = await DashboardController.getEvents(payload);
      if (response.result) {
        this.event_data = response.data || [];
        this.totalRows = this.event_data.length;
        
        // Check multiple possible property names for total count
        this.totalRowsCount = response.totalCount || 
                              response.total || 
                              response.count ||
                              response.totalRecords ||
                              response.totalItems ||
                              0;
        
        // If no total count is provided and we have a full page of data,
        // assume there might be more pages
        if (this.totalRowsCount === 0 && this.event_data.length === this.perPage) {
          this.totalRowsCount = this.event_data.length * 2; // Estimate at least 2 pages
        } else if (this.totalRowsCount === 0) {
          this.totalRowsCount = this.event_data.length;
        }
      }
      this.loading = false;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    updatePerPage(newPerPage) {
      this.perPage = newPerPage;
      this.currentPage = 1;
      this.getEvent('', this.dateRanges);
    }
  },
};
</script>




<style scoped>
/* No Data State - Dashboard Only */
.no-data-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 200px;
}

.no-data-image {
  width: 318px;
  height: 283px;
  object-fit: contain;
}

/* Dashboard Events Styles */
.events-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px 0px 0px;
}

.events-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  color: #3A3A3A;
  margin: 0;
}

/* Dashboard Table Styles */
.dashboard-table-container {
  width: 100%;
  overflow: hidden;
  margin-bottom: 0;
}

.dashboard-events-main-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 0 20px 20px 20px;
}

.dashboard-table-container .dashboard-events-table {
  border: 1px solid #D2E3FB !important;
  border-radius: 20px !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  overflow: hidden;
}

.dashboard-table-container .dashboard-events-table >>> thead th {
  padding: 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  font-weight: 600 !important;
  color: #161616 !important;
  border-bottom: none !important;
  border-top: none !important;
}

.dashboard-table-container .dashboard-events-table >>> tbody tr td {
  padding: 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  color: #161616;
  border-bottom: 1px solid #E5E7EB !important;
}

.dashboard-table-container .dashboard-events-table >>> tbody tr:last-child td {
  border-bottom: none !important;
}

.event-name {
  font-family: 'Poppins', sans-serif;
  text-decoration: none;
}

.event-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px !important;
  border-radius: 20px;
  font-weight: 500;
  color: #FFFFFF;
  min-width: 100px;
  justify-content: center;
}

.event-badge img,
.event-badge svg {
  flex-shrink: 0;
}

.status-started {
  border-radius: 16px;
  background: rgba(0, 127, 231, 0.10);
  color: #007FE7;
}

.status-paused {
  border-radius: 16px;
  background: rgba(52, 64, 84, 0.10);
  color: #344054;
}

.status-down {
  border-radius: 16px;
  background: rgba(231, 0, 0, 0.10);
  color: #E70000;
}

.status-up {
  border-radius: 16px;
  background: rgba(47, 178, 52, 0.10);
  color: #2FB234;
}


/* Events Page Styles */
.events-main-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 0 30px 30px 30px;
}

/* Remove all borders from events table */
.events-main-container .events-table-container {
  border: none !important;
  box-shadow: none !important;
}

.events-main-container .events-page-table.table {
  border: none !important;
  box-shadow: none !important;
}

.events-main-container .events-page-table >>> tr,
.events-main-container .events-page-table >>> td,
.events-main-container .events-page-table >>> th {
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
}

.events-page-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  color: #161616;
  margin: 0;
}

.events-table-container {
  width: 100%;
  overflow: hidden;
  margin-bottom: 0;
  padding: 0 !important;
}

.events-table-container .events-page-table {
  border: none !important;
  border-radius: 20px !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  overflow: hidden;
  margin-top: 20px;
  width: 100% !important;
}

.events-table-container .events-page-table >>> thead th {
  padding: 15px 0 !important;
  font-family: 'Poppins', sans-serif;
  font-weight: 600 !important;
  color: #161616 !important;
  border-bottom: 1px solid #E5E7EB !important;
  border-top: none !important;
  background-color: transparent !important;
}

.events-table-container .events-page-table >>> thead th:first-child {
  padding-left: 30px !important;
}

.events-table-container .events-page-table >>> thead th:last-child {
  padding-right: 30px !important;
}

.events-table-container .events-page-table >>> tbody tr td {
  padding: 20px 0 !important;
  font-family: 'Poppins', sans-serif;
  color: #161616;
  border-bottom: 1px solid #E5E7EB !important;
}

.events-table-container .events-page-table >>> tbody tr td:first-child {
  padding-left: 30px !important;
}

.events-table-container .events-page-table >>> tbody tr td:last-child {
  padding-right: 30px !important;
}

.monitor-name-text {
  font-family: 'Poppins', sans-serif;
  color: #161616;
  text-decoration: none;
}


.badge-secondary {
  background-color: gray !important;
}

/* Table responsive wrapper */
.table-responsive-custom {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Ensure all table text uses Poppins font */
.dashboard-events-table,
.events-page-table {
  font-family: 'Poppins', sans-serif;
}

/* Text truncation for small screens */
.cust_txt {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  display: inline-block;
}

.monitor-name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  display: inline-block;
}

/* Responsive Styles */
@media (max-width: 1200px) {

  .event-badge {
    min-width: 80px;
    font-size: 14px;
    padding: 3px 10px !important;
  }
  
  .event-badge img {
    width: 14px;
    height: 14px;
  }
}

@media (max-width: 992px) {
  
  .cust_txt,
  .monitor-name-text {
    max-width: 120px;
  }
}

/* Responsive Styles */
@media (max-width: 768px) {
  /* Remove horizontal padding on mobile */
  .dashboard-events-main-container,
  .events-main-container {
    padding: 0 10px 10px 10px;
  }
  
  /* Make table containers full width */
  .dashboard-table-container,
  .events-table-container {
    margin: 0;
    border-radius: 12px !important;
  }
  
  /* Adjust table styles for mobile */
  .dashboard-table-container .dashboard-events-table,
  .events-table-container .events-page-table {
    border-radius: 12px !important;
  }
  
  .events-header {
    padding: 15px 0 10px 0;
  }
  
  /* Smaller event badges */
  .event-badge {
    min-width: 70px;
    font-size: 11px !important;
    padding: 2px 8px !important;
    gap: 3px;
  }
  
  .event-badge img {
    width: 12px;
    height: 12px;
  }
  
  /* Text truncation for mobile */
  .cust_txt,
  .monitor-name-text {
    max-width: 80px;
    font-size: 12px !important;
  }
  
  /* Font size adjustments */
  .custom-font-32 {
    font-size: 20px !important;
  }
  
  .custom-font-22 {
    font-size: 14px !important;
  }
  
  .custom-font-16 {
    font-size: 12px !important;
  }
  
  .custom-font-16 {
    font-size: 11px !important;
  }
  
  
  /* Hide table borders on mobile for cleaner look */
  .table-responsive-custom {
    overflow-x: visible;
  }
  
  /* Use Bootstrap's stacked mode on mobile */
  .dashboard-events-table.b-table-stacked-md,
  .events-page-table.b-table-stacked-md {
    border: none !important;
  }
}

/* Very small devices */
@media (max-width: 576px) {
  .no-data-image {
    width: 200px;
    height: 180px;
  }
}

@media (max-width: 480px) {
  .dashboard-events-main-container,
  .events-main-container {
    padding: 0 5px 5px 5px;
    border-radius: 12px;
  }
  
  /* Even smaller text for very small screens */
  .cust_txt,
  .monitor-name-text {
    max-width: 60px;
  }
  
  .event-badge {
    min-width: 60px;
    font-size: 10px !important;
  }
}
.simple-pagination-bar {
  background: none;
  border: none;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pagination-btn-group {
  display: flex;
  align-items: center;
}
.simple-page-btn {
  padding: 10px 16px;
  border: 1px solid #D0D5DD;
  background: #FFFFFF;
  border-radius: 10px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  color: #344054;
  cursor: pointer;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  transition: all 0.2s ease;
  outline: none;
}

.simple-page-btn:hover:not(:disabled) {
  background: #F9FAFB;
}

.simple-page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.per-page-info-box {
  background: #fff;
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  padding: 0px 10px;
  font-size: 16px;
  font-family: 'Inter', sans-serif;
  color: #344054;
  font-weight: 500;
  margin-left: 16px;
}
.per-page-icon {
  width: 20px;
  height: 20px;
}
.per-page-label {
  font-size: 16px;
  color: #344054;
  font-weight: 500;
}
.select-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}
.per-page-select {
  width: auto;
  border: none;
  background: transparent;
  font-size: 16px;
  font-weight: 500;
  padding: 0 10px 0 5px;
  color: #344054;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.per-page-select:focus {
  box-shadow: none;
  outline: none;
}
.select-icon {
  position: absolute;
  right: 2px;
  pointer-events: none;
  color: #344054;
  font-size: 18px;
}

/* Pagination visibility control */
.complex-pagination-wrapper {
  display: block;
}

.simple-pagination-container {
  display: none !important;
}

/* When screen is less than 1650px, switch to simple pagination */
@media (max-width: 1649px) {
  .complex-pagination-wrapper {
    display: none !important;
  }
  
  .simple-pagination-container {
    display: block !important;
  }
}

/* Simple Pagination for Dashboard when screen < 1650px */
.simple-pagination-container {
  margin-top: 20px;
  padding: 0;
}

.simple-pagination-wrapper {
  padding: 15px 0;
  width: 100%;
}

.per-page-selector-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.per-page-label-simple {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #344054;
  font-weight: 500;
}

.per-page-select-simple {
  width: auto;
  min-width: 80px;
  height: 36px;
  border: 1px solid #D0D5DD;
  border-radius: 10px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #344054;
  font-weight: 500;
  padding: 0 30px 0 10px;
  background-color: #FFFFFF;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.per-page-select-simple:focus {
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.page-info-text-simple {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #344054;
  font-weight: 500;
  margin-right: 10px;
}

.simple-page-btn-dashboard {
  padding: 10px 16px;
  border: 1px solid #D0D5DD;
  background: #FFFFFF;
  border-radius: 10px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  color: #344054;
  cursor: pointer;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  transition: all 0.2s ease;
}

.simple-page-btn-dashboard:hover:not(:disabled) {
  background: #F9FAFB;
}

.simple-page-btn-dashboard:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive adjustment for simple pagination */
@media (max-width: 768px) {
  .no-data-image {
    width: 250px;
    height: 220px;
  }

  .simple-pagination-wrapper {
    flex-direction: column;
    gap: 15px;
  }
  
  .per-page-selector-wrapper,
  .pagination-controls {
    width: 100%;
    justify-content: center;
  }
  
  .page-info-text-simple {
    margin-right: 5px;
    font-size: 12px;
  }
  
  .simple-page-btn-dashboard {
    padding: 5px 12px;
    font-size: 12px;
  }
  
  .per-page-label-simple {
    font-size: 12px;
  }
  
  .per-page-select-simple {
    font-size: 12px;
    height: 32px;
    min-width: 70px;
  }
}
</style>